// extracted by mini-css-extract-plugin
module.exports = {"container":"paymentRedirect_container__1TziX","logo":"paymentRedirect_logo__1K5RQ"};